import ActivityType from "types/ActivityType";
import LikeButton from "components/likes/LikeButton";
import ActivityLink from "./ActivityLink";

export interface Props {
  activity: ActivityType;
}

export default function ActivityFooter({ activity }: Props) {
  return (
    <div className="space-x-2 flex items-center justify-between flex-row">
      <LikeButton likeable={activity} />

      <p className="md:hidden">
        <ActivityLink activity={activity} />
      </p>
    </div>
  );
}
